import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { Base, Stack } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { SocialsWrapper } from '../../components/SocialsWrapper/index.js';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.js';
import { loginSourceSelector } from '../../redux/core/sourceData/sourceDataSlice.js';
import { hasSocialAuthConsent } from '../../redux/core/consent/consentSlice.js';
import { LoginNegativeAlert } from '../../components/Login/LoginNegativeAlert/index.js';
import { useTranslatedSourceOverrideLabel } from '../../helpers/useTranslatedLabel.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { emailChangeAlertStatusSelector, setEmailChangeAlertStatus, } from './loginSlice.js';
import { storageKeys } from '../../configs/constants/storageKeys.js';
import { PasswordResetSuccessAlert, ChangeEmailAlert, LoginFooter, LoginWithEmailForm, LoginWithGoogle, LoginWithFacebook, LoginConsent, } from '../../components/Login/index.js';
import { addDataDogAction, DD_ACTIONS } from '../../logging/datadog.js';
import { ContentHeading } from '../../components/common/ContentHeading/index.js';
import { HeaderDescription } from '../../components/common/HeaderDescription/index.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
import { activeWrapperSelector, setActiveView, } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
export const LoginForm = () => {
    const { t } = useTranslation();
    const loginSource = useAppSelector(loginSourceSelector);
    const emailChangeAlert = useAppSelector(emailChangeAlertStatusSelector);
    const hasSocialAuthConsentAccepted = useAppSelector(hasSocialAuthConsent);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const useSourceOverrideLabel = useTranslatedSourceOverrideLabel(loginSource, t);
    const dispatch = useAppDispatch();
    const headerLabel = useSourceOverrideLabel('login.header');
    const descriptionLabel = useSourceOverrideLabel('login.body');
    const { trackModalComponentVisible } = useTrack('standard');
    useEffect(() => {
        const isEmailChangeSuccessful = sessionStorage.getItem(storageKeys.isEmailChangeSuccessful) === 'true';
        if (isEmailChangeSuccessful) {
            dispatch(setEmailChangeAlertStatus(isEmailChangeSuccessful));
        }
        if (activeWrapper === 'modal' || activeWrapper === 'stepModal') {
            addDataDogAction(DD_ACTIONS.DISPLAY_LOGIN_MODAL_STANDARD);
            dispatch(setActiveView(FORM_TYPES.LOGIN));
            trackModalComponentVisible();
        }
        else {
            dispatch(setActiveView(FORM_TYPES.LOGIN));
        }
    }, []);
    const searchParams = useSearchParams();
    const isPasswordReset = searchParams && searchParams.get('passwordReset') === '1';
    const onDismissEmailChanged = () => {
        dispatch(setEmailChangeAlertStatus(false));
        sessionStorage.removeItem(storageKeys.isEmailChangeSuccessful);
    };
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceS'], "data-testid": "login-form", children: [_jsx(ChangeEmailAlert, { isVisible: emailChangeAlert, onDismiss: onDismissEmailChanged }), isPasswordReset && _jsx(PasswordResetSuccessAlert, {}), _jsx(ContentHeading, { label: headerLabel }), _jsx(HeaderDescription, { label: descriptionLabel }), _jsx(LoginNegativeAlert, {}), _jsx(LoginWithEmailForm, {}), hasSocialAuthConsentAccepted && (_jsx(Base, { pt: 'spaceS', children: _jsxs(SocialsWrapper, { children: [_jsx(LoginWithGoogle, {}), _jsx(LoginWithFacebook, {})] }) })), _jsx(LoginConsent, {}), _jsx(LoginFooter, {})] }));
};
//# sourceMappingURL=LoginForm.js.map